import { get } from "../common/remote/base_api";

export const GetDriverreq = () => {
  return get(`admin/get-driver-request-list/`);
};